import { render } from "./ManiaChat.vue?vue&type=template&id=01449a39&scoped=true"
import script from "./ManiaChat.vue?vue&type=script&lang=js"
export * from "./ManiaChat.vue?vue&type=script&lang=js"

import "./ManiaChat.vue?vue&type=style&index=0&id=01449a39&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01449a39"]])

export default __exports__